module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"profiles":"Profiles","noProfilesAdded":"This cloud doesn\u0027t contain any profiles yet","noProfilesFound":"No matching profiles found","columns":"Columns"},"ru":{"profiles":"Профили","noProfilesAdded":"В этом облаке пока нет профилей","noProfilesFound":"Профили, соответствующие вашему запросу, не найдены","columns":"Колонки"}}')
  delete Component.options._Ctor
}
